import { render, staticRenderFns } from "./PatrimonioListagemGrade.vue?vue&type=template&id=0e687a08&scoped=true&"
import script from "./PatrimonioListagemGrade.vue?vue&type=script&lang=js&"
export * from "./PatrimonioListagemGrade.vue?vue&type=script&lang=js&"
import style0 from "./PatrimonioListagemGrade.vue?vue&type=style&index=0&id=0e687a08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e687a08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VFlex,VIcon,VLayout,VPagination,VRow,VSelect,VSpacer})
